import { MenuStyleInterface } from './menu-style.interface';
import { MenuDarkTheme } from './menu.dark-theme';

export const MenuLightTheme: MenuStyleInterface = MenuDarkTheme;
